"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = void 0;
const tslib_1 = require("tslib");
const errors_1 = require("./errors");
const defaultHeaders = {
    "Content-Type": "application/json"
};
/**
 *
 * */
const post = (server, endpoint, payload, headers) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    headers = Object.assign(defaultHeaders, headers);
    const payloadJSON = {
        method: "post",
        headers: headers,
        body: JSON.stringify(payload),
    };
    const response = yield fetch(server + endpoint, payloadJSON);
    const responseJSON = yield response.json();
    if (response.ok) {
        return responseJSON;
    }
    const { code } = responseJSON;
    throw new errors_1.SDKError(code, errors_1.getErrorMessageByCode(code), []);
});
exports.post = post;
//# sourceMappingURL=http.js.map